import { useState, useEffect } from 'react';
import styles from '../../styles/components/ui/Carousel.module.css';

const Carousel = ({ images, autoPlay = true, interval = 7000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const togglePause = (e) => {
    e.stopPropagation(); // Empêche le déclenchement des événements parents
    setIsPaused(!isPaused);
  };

  useEffect(() => {
    if (!autoPlay || isPaused) return;
    
    const timer = setTimeout(() => {
      nextSlide();
    }, interval);

    return () => clearTimeout(timer);
  }, [currentIndex, isPaused, autoPlay, interval]);

  if (!images || images.length === 0) {
    console.log('Aucune image fournie au carrousel');
    return <div style={{ padding: '20px', background: '#ffebee' }}>
      Aucune image à afficher dans le carrousel
    </div>;
  }

  console.log('Rendu du carrousel avec l\'image:', images[currentIndex]);
  
  return (
    <div 
      className={styles.carousel} 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button 
        onClick={prevSlide} 
        className={`${styles.control} ${styles.prev}`}
        aria-label="Image précédente"
      >
        &lt;
      </button>
      
      <div className={styles.slideContainer}>
        <img 
          src={images[currentIndex]} 
          alt={`Slide ${currentIndex + 1}`} 
          className={styles.slideImage}
        />
        <div className={styles.dots}>
          {images.map((_, index) => (
            <span
              key={index}
              className={`${styles.dot} ${index === currentIndex ? styles.active : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Aller à l'image ${index + 1}`}
            />
          ))}
        </div>
      </div>
      
      <button 
        onClick={nextSlide} 
        className={`${styles.control} ${styles.next}`}
        aria-label="Image suivante"
      >
        &gt;
      </button>
      
      <div 
        className={`${styles.pausePlay} ${isHovered || isPaused ? styles.visible : ''}`}
        onClick={togglePause}
        title={isPaused ? 'Reprendre le diaporama' : 'Mettre en pause'}
        aria-label={isPaused ? 'Reprendre le diaporama' : 'Mettre en pause'}
      >
        {isPaused ? '▶' : '❚❚'}
      </div>
    </div>
  );
};

export default Carousel;
